import { __module as o } from "./chunk671.js";
import { __require as d } from "./chunk447.js";
import { __require as _ } from "./chunk464.js";
var h = o.exports, m;
function R() {
  return m ? o.exports : (m = 1, function(x, C) {
    (function(f, i, s) {
      x.exports = i(d(), _());
    })(h, function(f) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return f.mode.CTRGladman = function() {
        var i = f.lib.BlockCipherMode.extend();
        function s(e) {
          if ((e >> 24 & 255) === 255) {
            var n = e >> 16 & 255, r = e >> 8 & 255, t = e & 255;
            n === 255 ? (n = 0, r === 255 ? (r = 0, t === 255 ? t = 0 : ++t) : ++r) : ++n, e = 0, e += n << 16, e += r << 8, e += t;
          } else
            e += 1 << 24;
          return e;
        }
        function p(e) {
          return (e[0] = s(e[0])) === 0 && (e[1] = s(e[1])), e;
        }
        var v = i.Encryptor = i.extend({
          processBlock: function(e, n) {
            var r = this._cipher, t = r.blockSize, c = this._iv, u = this._counter;
            c && (u = this._counter = c.slice(0), this._iv = void 0), p(u);
            var l = u.slice(0);
            r.encryptBlock(l, 0);
            for (var a = 0; a < t; a++)
              e[n + a] ^= l[a];
          }
        });
        return i.Decryptor = v, i;
      }(), f.mode.CTRGladman;
    });
  }(o), o.exports);
}
export {
  R as __require
};
